/* eslint-disable import/prefer-default-export */
export const getSystemNotification = (state) => state.popups.displaySystemNotificationPopup;